import styled from 'styled-components';

import {breakpoints} from '../../constants/Breakpoints';
import {StyledBattlePassFooterContainer, StyledPlayButtonWrapper} from '../battlePass/CtaFooter';

const StyledBackgroundImageVideo = styled.div`
  position: relative;
  & .logo {
    max-width: 700px;
    margin: 0 auto;
    padding-top: 2em;

    & h1 {
      font-size: 1.18em;
    }
    & img {
      max-width: 100%;
    }

    @media ${breakpoints.tablet} {
      padding-bottom: 1em;
      & img {
        padding: 1em 0;
      }
      & h1 {
        margin: 0.2em;
      }
    }
  }

  & ${StyledBattlePassFooterContainer} {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    z-index: 10;

    & img.image-cta-background {
      max-width: 100%;
    }

    ${StyledPlayButtonWrapper} {
      font-size: 3.6rem;

      &&& p {
        font-size: 3.6rem;
      }

      & span.videoPlayButton {
        width: 6rem;
        height: 6rem;
        border-width: 2px;

        & span {
          font-size: 1.5rem;
        }
      }
      @media ${breakpoints.mobileL} {
        font-size: 2.4rem;
        &&& p {
          font-size: 2.4rem;
        }
        & span.videoPlayButton {
          width: 4rem;
          height: 4rem;

          & span {
            font-size: 1rem;
          }
        }
      }
    }
  }
`;
export default StyledBackgroundImageVideo;
